// 白名单路由 —— 无权限用户也能访问 (登录、错误页) 或者作为兜底 (404)。
// 所有业务页面走 store.user.menuTree → dynamicRoutes.buildRoutes → router.addRoute 动态挂载,
// 目的是"没权限的页面前端根本没有这条路由",避免任何 canVisit 之类的事后拦截逻辑。
export default [
  {
    path: "/",
    redirect: "/client/loginTest",
  },
  {
    path: "/client/loginTest",
    name: "Login",
    component: () => import("@v/basePage/Login.vue"),
    meta: { public: true },
  },
  {
    path: "/client/forbidden",
    name: "Forbidden",
    component: () => import("@v/basePage/Forbidden.vue"),
    meta: { public: true },
  },
  // 404 必须放最后。addRoute 里的动态路由都是 push 到路由表尾之前,所以这个 * 兜底
  // 由 router/index.js 在动态挂载完成后 addRoute 一次。这里保留占位以便 IDE 索引。
];

export const NOT_FOUND_ROUTE = {
  path: "*",
  name: "NotFound",
  component: () => import("@v/basePage/NotFound.vue"),
  meta: { public: true },
};
